var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccess = function SvgSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.995c7.182 0 13.005 5.823 13.005 13.005S25.182 31.005 18 31.005 4.995 25.182 4.995 18 10.818 4.995 18 4.995M18 0C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18A18 18 0 0 0 18 0z",
    fill: "#80CB7E",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2.98c-8.277 0-14.986 6.71-14.986 14.987 0 8.276 6.71 14.986 14.986 14.986 8.277 0 14.986-6.71 14.986-14.986C32.986 9.69 26.276 2.98 18 2.98z",
    fill: "#80CB7E",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.455 12.564A1.828 1.828 0 0 0 24.139 12c-.493 0-.966.203-1.315.564l-7.016 7.267-2.632-2.725a1.828 1.828 0 0 0-1.315-.564c-.494 0-.967.203-1.316.564A1.961 1.961 0 0 0 10 18.47c0 .51.196 1 .545 1.362l3.508 3.632c.477.494 1.143.631 1.754.477.611.154 1.277.017 1.755-.477l7.893-8.174A1.96 1.96 0 0 0 26 13.927c0-.511-.196-1.001-.545-1.363z",
    fill: "#FFF"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.d5c938c28eb26156a8f6300d0a5ef942.svg";